export class Context {
  isThemeDark: boolean = false;

  consumerId: number = 0;
  consumerName: string = "";

  organizationId: number = 0;
  organizationName: string = "";

  branchId: number = 0;
  branchName: string = "";
  branchMobile: string = "";
  branchLandLineNumber: string = "";

  departmentId: number = 0;
  departmentName: string = "";

  specialityId: number = 0;
  specialityName: string = "";

  //LOCATION
  locationId: number = 0;
  doctorId: number = 0;
  locationName: string = "";
  locationCity: string = "";
  locationTypeCode: string = "";
  doctorName: string = "";
  locationAddress: string = "";
  locationCount: number = 0;

  defaultPrescriptionTemplate: string = "";
  defaultBillingTemplate: string = "";

  loginDetail: LoginDetail = new LoginDetail();

  appointmentUrl: string = "";
  appointmentLink: string = "";
  referBookUrl: string = "";

  isAlert: boolean = false;
  alertMessage: string = "";
  alertType: string = "success";

  maxOrganizations: number = 0;
  isMenuVisible: boolean = false;

  subscriptionId: number = 0;
  subscriptionDetailId: number = 0;
  planId: number = 0;
  maxOrg: number = 0;
  maxBranch: number = 0;
  maxUser: number = 0;
  maxDepartments: number = 0;

  financialYearDetail: FinancialYearDetail = new FinancialYearDetail();

  systemConfigurationColl: Array<SystemConfiguration> = [];
  systemConfigurationDetailColl: Array<SystemConfigurationDetail> = [];
  allowedSystemColl: Array<AllowedSystem> = [];

  userId: number = 0;
  DataManagedBy: number = 0;
  mode: string = "";

  planStartDate: string = "";
  planEndDate: string = "";

  whatsAppRemainingCredits: number = 0;

  // spouseFamilyMemberId: number = 0;
  // currFamilyMemberId: number = 0;

  // memberDetail: MemberDetail = new MemberDetail();
  // moduleConfiguration: any = [];

  // mobileNumber: string = "";
  // stage: string = "";
  // expectingChildNo: number = 0;
  // curMemberSelected: string = "";
  // curMaternalDetailId: number = -1;
  // isGoToMaternalDetail: boolean = false;
  // isComeFromStageSelection: boolean = false;
  // moduleConfigurationLoading: boolean = false;
  // memberDetailLoading: boolean = false;
  // isRegistrationComplete: boolean = false;
  // isAddMember: boolean = false;
  // isAddMemberFromList: boolean = false;
  // isEditMemberFromBottomSheet: boolean = false;
  // isEditMaternalDetail: boolean = false;
  // isAddMaternalDetail: boolean = false;
  // isEditMemberFromList: boolean = false;
  // isBabyDelivered: boolean = false;
  // isAddChildDetail: boolean = false;
  // isEdit: boolean = false
  // isMotherExist: boolean = false;
  // isUnauthorized: boolean = false;
  // isWifePregnant: boolean = false;

  // dateOfDelivery: string = "";
  // symptomsCategoryCode: string = "";
  // symptomsCategoryName: string = "";
  // symptomsCode: string = "";
  // symptomsName: string = "";

  // DEFAULT DATA
  strengthUnitColl: Array<selectOption> = [];
  perVolumeUnitColl: Array<selectOption> = [];
  printUnitColl: Array<selectOption> = [];
  packagePerVolumeUnitColl: Array<selectOption> = [];
  packageUnitColl: Array<selectOption> = [];
  frequencyUnitColl: Array<selectOption> = [];
  perIntervalUnitColl: Array<selectOption> = [];
  treatmentDurationUnitColl: Array<selectOption> = [];

  isRefreshStrengthUnit: boolean = false;
  isRefreshPerVolumeUnit: boolean = false;
  isRefreshPrintUnit: boolean = false;
  isRefreshPackagePerVolumeUnit: boolean = false;
  isRefreshPackageUnit: boolean = false;
  isRefreshFrequencyUnit: boolean = false;
  isRefreshPerIntervalUnit: boolean = false;
  isRefreshTreatmentDurationUnit: boolean = false;

  memberDetail: MemberDetail = new MemberDetail();

  dataStorage: DataStorage = new DataStorage();
}

export class LoginDetail {
  token: string = "";
  tokenExpiryTime: string = "";
  userId: number = 0;
  userKey: string = "";
  userRole: any = "";
  loginClick: boolean = true;
  prefix: string = "";
  firstName: string = "";
  lastName: string = "";
  fullName: string = "";
  email: string = "";
  countryID: number = 91;
  isAuthorized: boolean = true;
  ipAddress: string = "";
  deviceInfo: string = "";
}

export class MemberDetail {
  age: number = 0;
  birthDate: string = "";
  familyId: number = 0;
  familyMemberId: number = 0;
  familyRelationName: string = "";
  firstName: string = "";
  lastName: string = "";
  gender: string = "";
  isPrematureChild: boolean = false;
  isSpecialChild: boolean = false;
  profileImageBase: string = "";
  curMemberSelectedLanguage: string = "";
  maternalDetailId: number = 0;
  complicationsDetails: string = "";
  expectingChildNo: number = 0;
  expectingDateOfDelivery: string = "";
  gestationalAge: number = 0;
  gestationalAgeTime: string = "";
  isChildBorn: boolean = false;
  isTermination: boolean = false;
  isPragnentExpectingChild: boolean = false;
  lastManstrualPeriodDate: string = "";
  notificationCount: number = 0;
}

export class FinancialYearDetail {
  financialYear: string = "";
  financialYearStartDate: Date = new Date();
  financialYearEndDate: Date = new Date();
}

export interface SystemConfiguration {
  systemConfigurationId: number;
  systemConfigurationDefaultId: number;
  configModule: string;
  configValue: string;
  configKey: string;
  configDataType: string;
  isDeleted: boolean;
}

export interface selectOption {
  label: string;
  value: string;
}

export interface SystemConfigurationDetail {
  systemConfigurationId: number;
  systemConfigurationDefaultId: number;
  systemConfigurationDetailId: number;
  configModule: string;
  configKey: string;
  configKeyLabel: string;
  configValue: string;
  configDataType: string;
  isDeleted: boolean;
  displayOrder: number;
}
export class AllowedSystem {
  specialityId: number = 0;
  examinationSystemCode: string = "";
  examinationSystemName: string = "";
  examinationSystemDisplayCode: string = "";
  displayOrder: number = 0;
}

export class DataStorage {
  isRefreshStrengthUnit: boolean = false;
  strengthUnitColl: Array<selectOption> = [];

  isRefreshPerVolumeUnit: boolean = false;
  perVolumeUnitColl: Array<selectOption> = [];

  isRefreshPrintUnit: boolean = false;
  printUnitColl: Array<selectOption> = [];

  isRefreshPackagePerVolumeUnit: boolean = false;
  packagePerVolumeUnitColl: Array<selectOption> = [];

  isRefreshPackageUnit: boolean = false;
  packageUnitColl: Array<selectOption> = [];

  isRefreshFrequencyUnit: boolean = false;
  frequencyUnitColl: Array<selectOption> = [];

  isRefreshPerIntervalUnit: boolean = false;
  perIntervalUnitColl: Array<selectOption> = [];

  isRefreshTreatmentDurationUnit: boolean = false;
  treatmentDurationUnitColl: Array<selectOption> = [];
}
